<template>
    <div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>交易单号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.no}}</span>
                    </div>
                </div>
            </div>
            <div v-if="tradeVoucherType == 2">
                <div class="form-row">
                    <div class="form-label">
                        <label>系统合同编号</label>
                    </div>
                    <div class="form-value">
                        <div class="value">
                            <span>{{voucher.contractNo}}</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label>合同编号</label>
                    </div>
                    <div class="form-value">
                        <div class="value">
                            <span>{{voucher.sndPartyHtBh}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row" v-else>
                <div class="form-label">
                    <label>订单号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.orderNo}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>客户名称</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.buyerName}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>是否手工创建</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.manualFlag">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <div class="value">{{voucher.creatorName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>创建日期</label>
                </div>
                <div class="form-value">
                    <div class="value">{{voucher.createTime}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import tradeApi from '../../api/trade'
    export default{
        name: 'swb-trade-voucher-detail',
        desc: '交易单详情',
        props: ["tradeId", 'tradeVoucherType'],
        data: function () {
            return {
                voucher: {}
            }
        },
        created: function () {
            //
            this.getVoucherDetail(this.tradeId);
        },
        methods: {
            getVoucherDetail: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                tradeApi.getTradeVoucher(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.voucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherDetail.vue